import { Button, styled, Typography } from '@mui/material'
import { BackButton } from '$common/buttons'
import {
  goBackInProfilePanel,
  openPremiumFeaturesIntroduction,
} from '$logic/router'
import { t } from '$i18n'
import { WDiamondIcon } from '@weblite/icons'

export function MyAccountAppBar() {
  const onClick = () => {
    analite('OPEN_PREMIUM_FEATURE_INTRODUCTION', {
      source: 'MY_ACCOUNT',
    })
    void openPremiumFeaturesIntroduction()
  }
  return (
    <Root>
      <TitleBackWrapper>
        <BackButton onClick={goBackInProfilePanel} color="neutral900" />
        <Typography color="neutral900" variant="h3">
          {t('myAccount.account')}
        </Typography>
      </TitleBackWrapper>

      {/* <PremiumButton
        onClick={onClick}
        variant="contained"
        sx={{  // TODO: Remove later
          width: '128px',
          height: '40px',
        }}
      >
        <WDiamondIcon sx={{ color: 'yellow500' }} />
        <Typography color="neutral000" variant="subtitle3">
          {t('myAccount.plans')}
        </Typography>
      </PremiumButton> */}
    </Root>
  )
}

const Root = styled('div')`
  width: 100%;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.palette.neutral000};
  height: 56px;
`

const PremiumButton = styled(Button)`
  background: linear-gradient(267.61deg, #7841e7 0%, #38a9e1 99.81%);
  display: flex;
  align-items: center;
  gap: 4px;
  margin-right: auto;
`

const TitleBackWrapper = styled('div')`
  display: flex;
  align-items: center;
`
